<template>
  <div class="microphoneSettingHelp flexcenter">
    <transition>
      <div class="help flexcenter">
        <!-- 閉じるボタン -->
        <div class="modal-close" v-on:click="clickButton"></div>
        <div class="microphoneSettingHelpInner">
        <h3 class="helpHeadline font22">マイク設定について</h3>

        <dl class="helpDetail">
          <dt>マイクを正しく設定できない場合は、次のことを試してみてください。</dt>
          <dd>
            <ul>
              <li>ヘッドセットが接続されていることと、マイクが消音になっていないことを確認します。</li>
              <li v-if="platform.name == 'Chrome'" >使用しているヘッドセットが[マイクの選択]で選択されていることを確認します。</li>
              <li>音声が検出されやすいように、マイクを口に近付けます。</li>
              <li>周囲に雑音がないことを確認します。</li>
              <li>通常の速度ではっきりと話します。</li>
            </ul>
          </dd>

          <dt>次の手順で、システム設定を調整します。</dt>
          <dd>
            <ul>
              <li>マイクの入力レベルが低すぎないことを確認します。</li>
              <li>マイクが現在の入力デバイスとして選択されていることを確認します。</li>
              <li v-if="isFlash">以下の手順に従って、本サイトのマイク使用が許可されていることを確認します。</li>
              <li v-else-if="platform.name == 'Chrome' || platform.name == 'Firefox' || platform.name == 'Safari'">ブラウザの設定で、本サイトのマイク使用が許可されていることを確認します。</li>
              <li v-else-if="platform.name == 'Microsoft Edge'">Windowsのマイク設定で、[Microsoft Edge]がマイクを使用できるアプリとして設定されていることを確認します。</li>
              <span v-if="isFlash"><a class="help-anchor" href="http://www.sourcenext.com/support/qa/?faq=RS-08885" target="_blank">http://www.sourcenext.com/support/qa/?faq=RS-08885</a></span>
            </ul>
          </dd>

          <dt v-if="platform.name == 'Microsoft Edge'">ブラウザがマイク使用許可を確認してきた場合は、次の手順で操作します。</dt>
          <dd v-if="platform.name == 'Microsoft Edge'">
            <ul>
              <li>[一度のみ許可]または[常に許可]のどちらかを選択します。</li>
              <span>※[常に許可]を選択することをお勧めします。</span>
              <li>[一度のみ許可]または[常に許可]のどちらも選択しなかった場合は、本サイトの再表示が必要になります。</li>
            </ul>
          </dd>
          </ul>
        </dl>

        <button class="return" type="button" v-on:click="clickButton"><span class="close_text">戻る</span></button>
      </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

var platform = require('platform')

export default {
  name: 'microphoneSettingHelp',
  mixins: [
    common
  ],
  data: function() {
    return {
      isFlash: false,
    }
  },
  computed: {
    platform: () => platform,
  },
  methods: {
    clickButton: function() {
      this.$emit('close')
    }
  },
  mounted: function() {
    this.log("MicrophoneSettingHelp start mounted")
    this.isFlash = this.isForceFlash()
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// MicrophoneSettingHelp.vue?14ec28b0